var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-box"},[_c('project-info',{attrs:{"id":_vm.id,"tabs":_vm.tabs,"app_lists":_vm.app_lists,"project":_vm.project}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }